import React, { useState, useEffect } from 'react';

import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
} from '@chakra-ui/react';
import { PrismicRichText } from '@prismicio/react';


const Alert = ({ alert }) => {
    return (
        <Modal isOpen={alert.isOpen} onClose={alert.onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader></ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <PrismicRichText field={alert.dialog_content.richText} />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default function AlertModal({ alert }) {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsOpen(true);
        }, 2000);
        return () => clearTimeout(timer);
    }, [])

    return (
        <>
            {alert.show_alert_modal_dialog ? <Alert alert={{...alert, isOpen, onClose: () => setIsOpen(false)}} /> : null}
        </>
    )
}